import { render, staticRenderFns } from "./CertVerify.vue?vue&type=template&id=4395bb9a&scoped=true"
import script from "./CertVerify.vue?vue&type=script&lang=js"
export * from "./CertVerify.vue?vue&type=script&lang=js"
import style0 from "./CertVerify.vue?vue&type=style&index=0&id=4395bb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395bb9a",
  null
  
)

export default component.exports